import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Button, Container, Image, Segment, Table } from 'semantic-ui-react'

import back from '../../assets/images/angle-fuchsia.png'
import Modules from '../common/modules'
import { isUrl } from '../../helpers/chisels'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { format } from '../../helpers/timezones'
import { actions as participants } from '../../store/actions/participants'

class ParticipantJournals extends Component {
    constructor (props) {
        super(props)
        this.state = {
            journals: [],
            isDesktop: false
        }
        autoBind(this)
    }

    componentDidMount () {
        this.updatePredicate()
        window.addEventListener('resize', this.updatePredicate)
        // Fetch the journals.
        this.fetchJournals(this.props.module)
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.updatePredicate)
    }

    updatePredicate () {
        this.setState({ isDesktop: window.innerWidth > 1450 })
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.module !== nextProps.module) {
            // Fetch the journals.
            this.fetchJournals(nextProps.module)
        }
    }

    // Fetches the participant's journals for the given module.
    fetchJournals (module) {
        if (!module) {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Fetch journals.')
        this.setState({ journals: [] })
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/journals?module_id=${module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched journals.')
                this.setState({
                    journals: response.data
                })
            })
            .catch((error) => {
                // Failed to fetch journals.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch journals.', error)
                // Hide the error.
                this.setState({ journals: [] })
            })
    }

    // Changes to the module with the given ID.
    changeModule (module) {
        this.props.changeLocation({ module })
    }

    render () {
        const isDesktop = this.state.isDesktop
        return (
            <Container className='participant-journals'>
                <Segment
                    className='navigation-item'
                    onClick={(_e) => { this.props.onChangeSubsection(undefined) }}
                >
                    <Image src={back}/>
                    {tr('JOURNALS')}
                </Segment>
                <Modules
                    with0
                    language={this.props.language}
                    timezone={this.props.timezone}
                    onChangeModule={(module) => { this.changeModule(module) }}
                />
                <Segment className='journals'>
                    {/*<Grid className='journals-header'>*/}
                    {/*    <Grid.Row>*/}
                    {/*        <Grid.Column className='date'>{tr('DATE')}</Grid.Column>*/}
                    {/*        <Grid.Column className='time'>{tr('TIME')}</Grid.Column>*/}
                    {/*        {(isDesktop &&*/}
                    {/*            <Grid.Column className='time'>{tr('LOGGED_TIME')}</Grid.Column>*/}
                    {/*        )}*/}
                    {/*        <Grid.Column className='time'>{tr('TRIGGER')}</Grid.Column>*/}
                    {/*        <Grid.Column className='emotion'>{tr('EMOTION')}</Grid.Column>*/}
                    {/*        {(isDesktop &&*/}
                    {/*            <Grid.Column className='trigger-event'>*/}
                    {/*                {tr('TRIGGER_EVENT')}*/}
                    {/*            </Grid.Column>*/}
                    {/*        )}*/}
                    {/*        {(isDesktop &&*/}
                    {/*            <Grid.Column className='thoughts'>*/}
                    {/*                {tr('THOUGHTS')}*/}
                    {/*            </Grid.Column>*/}
                    {/*        )}*/}
                    {/*        {(isDesktop &&*/}
                    {/*            <Grid.Column className='behaviour'>*/}
                    {/*                {tr('BEHAVIOUR')}*/}
                    {/*            </Grid.Column>*/}
                    {/*        )}*/}
                    {/*        <Grid.Column className='buttons'>&nbsp;</Grid.Column>*/}
                    {/*    </Grid.Row>*/}
                    {/*</Grid>*/}
                    <div className='l4'>
                        <Table fixed singleLine>
                            <Table.Body>
                                {
                                    <Table.Row className='journals-header'>
                                        <Table.Cell className='date'>{tr('DATE')}</Table.Cell>
                                        <Table.Cell className='time'>{tr('TIME')}</Table.Cell>
                                        {(isDesktop &&
                                            <Table.Cell className='time'>{tr('LOGGED_TIME')}</Table.Cell>
                                        )}
                                        <Table.Cell className='time'>{tr('TRIGGER')}</Table.Cell>
                                        <Table.Cell className='emotion'>{tr('EMOTION')}</Table.Cell>
                                        {(isDesktop &&
                                            <Table.Cell className='trigger-event'>
                                                {tr('TRIGGER_EVENT')}
                                            </Table.Cell>
                                        )}
                                        {(isDesktop &&
                                            <Table.Cell className='thoughts'>
                                                {tr('THOUGHTS')}
                                            </Table.Cell>
                                        )}
                                        {(isDesktop &&
                                            <Table.Cell className='behaviour'>
                                                {tr('BEHAVIOUR')}
                                            </Table.Cell>
                                        )}
                                        <Table.Cell className='buttons'>&nbsp;</Table.Cell>
                                    </Table.Row>
                                } {
                                /* eslint-disable react/no-array-index-key */
                                this.state.journals.map((journal, index) => {
                                    return (
                                        <Table.Row
                                            key={`journal${index}`}
                                            className={index === this.state.journals.length - 1 ? 'last' : ''}
                                        >
                                            <Table.Cell className='date'>
                                                {format(journal.created, 'DD/MM/YYYY', this.props.timezone, this.props.language)}
                                            </Table.Cell>
                                            <Table.Cell className='time'>
                                                {format(journal.created, 'HH:mm', this.props.timezone, this.props.language)}
                                            </Table.Cell>
                                            {(isDesktop &&
                                                <Table.Cell className='time'>
                                                    {format(journal.updated, 'HH:mm', this.props.timezone, this.props.language)}
                                                </Table.Cell>
                                            )}
                                            <Table.Cell className='time'>
                                                {journal.Trigger === 'User' ? tr('PARTICIPANT') : tr('WRISTBAND')}
                                            </Table.Cell>
                                            <Table.Cell className='emotion'>
                                                {journal.Feeling}
                                            </Table.Cell>
                                            {(isDesktop &&
                                                <Table.Cell
                                                    className={`trigger-event ${isUrl(journal.Events) ? 'with-url' : ''}`}>
                                                    {isUrl(journal.Events) ? `[${tr('AUDIO_FILE')}]` : journal.Events}
                                                </Table.Cell>
                                            )}
                                            {(isDesktop &&
                                                <Table.Cell
                                                    className={`thoughts ${isUrl(journal.Thoughts) ? 'with-url' : ''}`}>
                                                    {isUrl(journal.Thoughts) ? `[${tr('AUDIO_FILE')}]` : journal.Thoughts}
                                                </Table.Cell>
                                            )}
                                            {(isDesktop &&
                                                <Table.Cell
                                                    className={`behaviour ${isUrl(journal.Behaviours) ? 'with-url' : ''}`}>
                                                    {isUrl(journal.Behaviours) ? `[${tr('AUDIO_FILE')}]` : journal.Behaviours}
                                                </Table.Cell>
                                            )}
                                            <Table.Cell className='buttons'>
                                                <Button
                                                    onClick={(_e) => { this.props.onOpenItem(journal.created) }}>
                                                    {tr('OPEN')}
                                                </Button>
                                            </Table.Cell>
                                        </Table.Row>
                                    )
                                })
                                /* eslint-enable react/no-array-index-key */
                            }
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.participants.location.item,
        language: state.settings.language,
        module: state.participants.location.module,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        changeLocation: _participants.changeLocation
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantJournals))



// WEBPACK FOOTER //
// ./src/components/participant-journals/index.js